import React, { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";

//Common
import { LoadingIndicator } from "../../common/VFX-UI/";

//App
import { queryKeys } from "./constants";
import { EMPTY_GUID, GRID_PAGE_SIZE } from "../../../utility/constants/constants";
import { RoleContextData, RoleState } from "../../../types/role";
import roleApi from "../../../app/model/api/roleApi";
import Role from "./Role";

export const RoleContext = React.createContext<RoleContextData | null>(null);

const RoleContainer = () => {
  const [state, setState] = useState<RoleState>({
    roleId: null,
  });

  const roleGridQuery = useQuery({
    queryKey: [queryKeys.getRoles],
    queryFn: () => roleApi.getAll({}),
  });

  const roleQuery = useQuery({
    queryKey: [queryKeys.getRole, state.roleId],
    queryFn: () => roleApi.get(state.roleId ?? EMPTY_GUID),
    enabled: state.roleId !== null,
  });

  const updateRoleId = async (roleId: string | null) =>
    setState((prevState) => ({
      ...prevState,
      roleId: roleId,
    }));

  const { mutate: deleteMutation } = useMutation<void, Error, string>({
    mutationFn: async (value: string) => {
      await roleApi.delete(value);
    },
  });

  const contextValue: RoleContextData = {
    data: roleQuery?.data?.result,
    id: state.roleId,
    pageSize: GRID_PAGE_SIZE,
    setId: updateRoleId,
    refetchGrid: () => roleGridQuery.refetch(),
  };

  return roleGridQuery.isLoading ? (
    <LoadingIndicator />
  ) : (
    <RoleContext.Provider value={contextValue}>
      <Role
        data={roleGridQuery?.data?.result}
        deleteMutation={deleteMutation}
      />
    </RoleContext.Provider>
  );
};

export default RoleContainer;
